import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-recipients-groups',
    templateUrl: './recipients-groups.component.html',
    styleUrls: ['./recipients-groups.component.scss'],
})
export class RecipientsGroupsComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}